import React from "react"
import {Box, Typography} from "@mui/material"
import {packagingTokens as tk} from "@/theme/packagingTokens"

type SectionCardProps = {
    title?: React.ReactNode
    subtitle?: React.ReactNode
    action?: React.ReactNode
    icon?: React.ReactNode
    padded?: boolean // false = flush body (e.g. for tables); default true
    sx?: object
    children: React.ReactNode
}

// A Rémi surface card with an optional header row (15/600 title + subtitle +
// right action). Shared section container for the redesigned tabs.
export default function SectionCard(props: SectionCardProps) {
    const {title, subtitle, action, icon, padded = true, sx, children} = props
    return (
        <Box
            sx={{
                backgroundColor: tk.color.surface,
                border: `1px solid ${tk.color.border}`,
                borderRadius: tk.radius.card,
                overflow: "hidden",
                ...sx,
            }}
        >
            {(title || action) && (
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 1,
                        px: 2.5,
                        py: 2,
                        borderBottom: `1px solid ${tk.color.borderLight}`,
                    }}
                >
                    <Box sx={{display: "flex", alignItems: "center", gap: 1, minWidth: 0}}>
                        {icon}
                        <Box sx={{minWidth: 0}}>
                            {title && (
                                <Typography sx={{fontSize: "15px", fontWeight: 600, color: tk.color.textPrimary}}>
                                    {title}
                                </Typography>
                            )}
                            {subtitle && (
                                <Typography sx={{fontSize: "13px", color: tk.color.textSecondary, mt: 0.25}}>
                                    {subtitle}
                                </Typography>
                            )}
                        </Box>
                    </Box>
                    {action}
                </Box>
            )}
            <Box sx={{p: padded ? 2.5 : 0}}>{children}</Box>
        </Box>
    )
}
